import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts a PascalCase enum name (e.g. "ReadyToShip") into a human readable,
 * space-separated string (e.g. "Ready To Ship"). Leaves already-spaced or
 * empty values unchanged.
 */
@Pipe({
  name: 'humanizeEnum',
  standalone: true
})
export class HumanizeEnumPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value
      // Insert a space between a lowercase/digit and an uppercase letter
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      // Insert a space between consecutive uppercase letters followed by a lowercase letter (e.g. "ABCd" -> "AB Cd")
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .trim();
  }
}
